<template>
  <section class="overview-tab">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-0">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                class="nav-link"
                style="cursor: pointer"
                :class="{ active: isActiveProfileTab }"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                @click="$emit('tab-changed', $event)"
              >
                Overview
              </a>

              <a
                class="nav-link"
                :class="{ active: isActiveEventHighlightsTab }"
                id="nav-event-highlights-tab"
                style="cursor: pointer"
                data-bs-toggle="tab"
                data-bs-target="#nav-event-highlights"
                type="button"
                role="tab"
                aria-controls="nav-event-highlights"
                aria-selected="false"
                @click="$emit('tab-changed', $event)"
              >
                Video Highlights
              </a>

              <a
                class="nav-link"
                :class="{ active: isActiveActivityTab }"
                id="nav-contact-tab3"
                style="cursor: pointer"
                data-bs-toggle="tab"
                data-bs-target="#nav-activities"
                type="button"
                role="tab"
                aria-controls="nav-activities"
                aria-selected="false"
                @click="$emit('tab-changed', $event)"
              >
                ACTIVITIES
              </a>
              <a
                class="nav-link"
                v-if="showGameShop"
                :class="{ active: isActiveInGameShopTab }"
                id="nav-in-game-shop-tab3"
                style="cursor: pointer"
                data-bs-toggle="tab"
                data-bs-target="#nav-in-game-shop"
                type="button"
                role="tab"
                aria-controls="nav-in-game-shop"
                aria-selected="false"
                @click="$emit('tab-changed', $event)"
              >
                In Game Shop
              </a>

              <a
                class="nav-link"
                v-if="showGifting"
                :class="{ active: isActiveGiftingTab }"
                id="nav-gifting-tab3"
                style="cursor: pointer"
                data-bs-toggle="tab"
                data-bs-target="#nav-gifting"
                type="button"
                role="tab"
                aria-controls="nav-gifting"
                aria-selected="false"
                @click="$emit('tab-changed', $event)"
              >
                Gifting
              </a>

              <!-- <a
                class="nav-link"
                :class="{ active: isActiveVaultRewardsTab }"
                id="nav-vault-rewards-tab3"
                style="cursor: pointer"
                data-bs-toggle="tab"
                data-bs-target="#nav-vault-rewards"
                type="button"
                role="tab"
                aria-controls="nav-vault-rewards"
                aria-selected="false"
                @click="$emit('tab-changed', $event)"
              >
                Vault Rewards
              </a> -->
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TabNavigation",
  props: {
    isActiveProfileTab: {
      type: Boolean,
      default: true,
    },
    isActiveActivityTab: {
      type: Boolean,
      default: false,
    },
    isActiveEventHighlightsTab: {
      type: Boolean,
      default: false,
    },
    isActiveInGameShopTab: {
      type: Boolean,
      default: false,
    },
    isActiveGiftingTab: {
      type: Boolean,
      default: false,
    },
    isActiveVaultRewardsTab: {
      type: Boolean,
      default: false,
    },
    showGameShop: {
      type: Boolean,
      default: false,
    },
    showGifting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["tab-changed"],
};
</script>
